PJQ.app.attachReadyEvent(function () {
	PJQ.modules.accessKeySignIn.initAccessKeySignIn();
});

PJQ.modules.accessKeySignIn = {
	routes: [
		{
			route: 'signin/accessKey',
			name: 'accessKeySignIn',
			callback: function () {
				PJQ.modules.signIn.initAccessKeySignIn();
			}
		}
	],
	initAccessKeySignIn: function () {
		//This route will probably end up being different
		// It will only be the sign on the page
		new PJQ.views.auth.AccessKeySignIn({
			el: $('#pjq-access-key-login-main')
		});
	}
};